<template>
  <section class=" w-100 prlx1 p-5 text-light" style="min-height: 50vh;">
    <section class="container col-12 col-md-10 mx-auto p-0 row justify-content-center">
      <p class="fw-bold text-center on-board" style="font-family: 'Dastnevis' !important;">"به نام خدا"</p>

      <div class="col-12 col-md-5 pt-5">
        <div>
          <!--                <span class = "fas fa-phone span0 me-3"></span>-->
          <p class="d-inline mb-0 on-board" style="font-family: 'Dastnevis' !important;">تلفن: 09032313681</p><br>
          <!--              </div>-->
          <!--              <div>-->
          <!--                <span class = "fas fa-envelope span0 me-3"></span>-->
          <span style="font-family: 'Dastnevis' !important;" class="on-board">ایمیل: </span>
          <p class="d-inline on-board" style="font-family: 'Caveat' !important; font-size: 25px  !important;">
            webagent.ir@gmail.com
          </p>
        </div>
        <div>
          <!--                <span class = "fas fa-map-marker-alt span0 me-3"></span>-->
          <p class="d-inline on-board" style="font-family: 'Dastnevis' !important;">
            نشانی: تهران شیان خیابان شهید فرشادی
            نبش کوچه خندان پلاک ۵ ساختمان آراتل طبقه 2، آموزشگاه تخصصی تهران آیلتس
          </p>
        </div>

      </div>
      <div class=" col-12 col-md-6 text-left">
        <img class="mt-5 mt-md-0" src="image/stu1.png" width="100%" alt="">
      </div>
    </section>
  </section>

</template>

<script>
export default {
  name: "TheHeader"
}
</script>

<style scoped>

</style>